import {
  CustomButton,
  CustomInputSelect,
  CustomTextInput,
} from '@Modules/core/components';
import CustomFormControl from '@Modules/core/components/form/CustomFormControl';
import { IClientFormMeta } from '@Modules/cardManagementSystem/prepaid/containers/formHandlers/cardHolder/prepaidApplication/prepaidApplication/client/ClientMeta';
import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';
import { FaSave } from 'react-icons/fa';

type Props = {
  onSubmit: any,
  meta: IClientFormMeta,
  isLoading?: boolean,
  isSubmitting?: boolean,
};

const ClientFormUI = ({ meta, onSubmit, isSubmitting, isLoading }: Props) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    // reset,
  } = useForm({ resolver: yupResolver(meta.schema) });

  return (
    <CC.Box w={'100%'} as={'form'} onSubmit={handleSubmit(onSubmit)}>
      
      <CC.Box shadow={"md"}
       width={'100%'} p={5}>          
        <CC.SimpleGrid columns={{base: 1, sm:1, md: 2, lg:3}} spacing={10}>
        <CustomFormControl
            label={meta.title.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.title.name]}
          >
          <CustomInputSelect
              meta={meta.title}
              register={register(meta.title.name)}
              hasError={errors[meta.title.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.firstname.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.firstname.name]}
          >
            <CustomTextInput
              meta={meta.firstname}
              register={register(meta.firstname.name)}
              hasError={errors[meta.firstname.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.lastname.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.lastname.name]}
          >
            <CustomTextInput
              meta={meta.lastname}
              register={register(meta.lastname.name)}
              hasError={errors[meta.lastname.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.surname.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.surname.name]}
          >
            <CustomTextInput
              meta={meta.surname}
              register={register(meta.surname.name)}
              hasError={errors[meta.surname.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.birthDate.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.birthDate.name]}
          >
            <CustomTextInput
              meta={meta.birthDate}
              register={register(meta.birthDate.name)}
              hasError={errors[meta.birthDate.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.birthPlace.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.birthPlace.name]}
          >
            <CustomTextInput
              meta={meta.birthPlace}
              register={register(meta.birthPlace.name)}
              hasError={errors[meta.birthPlace.name]}
            />
          </CustomFormControl>

          
          <CustomFormControl
            label={meta.firstIdentityType.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.firstIdentityType.name]}
          >
            <CustomInputSelect
              meta={meta.firstIdentityType}
              register={register(meta.firstIdentityType.name)}
              hasError={errors[meta.firstIdentityType.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.firstIdentity.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.firstIdentity.name]}
          >
            <CustomTextInput
              meta={meta.firstIdentity}
              register={register(meta.firstIdentity.name)}
              hasError={errors[meta.firstIdentity.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.secondIdentityType.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.secondIdentityType.name]}
          >
            <CustomInputSelect
              meta={meta.secondIdentityType}
              register={register(meta.secondIdentityType.name)}
              hasError={errors[meta.secondIdentityType.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.secondIdentity.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.secondIdentity.name]}
          >
            <CustomTextInput
              meta={meta.secondIdentity}
              register={register(meta.secondIdentity.name)}
              hasError={errors[meta.secondIdentity.name]}
            />
          </CustomFormControl>


          <CustomFormControl
            label={meta.gender.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.gender.name]}
          >
            <CustomInputSelect
              meta={meta.gender}
              register={register(meta.gender.name)}
              hasError={errors[meta.gender.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.familySituation.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.familySituation.name]}
          >
            <CustomInputSelect
              meta={meta.familySituation}
              register={register(meta.familySituation.name)}
              hasError={errors[meta.familySituation.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.nationality.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.nationality.name]}
          >
            <CustomInputSelect
              meta={meta.nationality}
              register={register(meta.nationality.name)}
              hasError={errors[meta.nationality.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.numberOfDependents.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.numberOfDependents.name]}
          >
            <CustomTextInput
              meta={meta.numberOfDependents}
              register={register(meta.numberOfDependents.name)}
              hasError={errors[meta.numberOfDependents.name]}
            />
          </CustomFormControl>

        </CC.SimpleGrid>
      </CC.Box>

      <CC.Box shadow={"md"}
       my={10} p={5}>
      <CC.Heading size='md'>Informations professionnelles </CC.Heading>
      <CC.SimpleGrid columns={{base: 1, sm:1, md: 2, lg:3}} spacing={10} my={10}>      
      <CustomFormControl
            label={meta.employeeCode.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.employeeCode.name]}
          >
            <CustomTextInput
              meta={meta.employeeCode}
              register={register(meta.employeeCode.name)}
              hasError={errors[meta.employeeCode.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.employeeName.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.employeeName.name]}
          >
            <CustomTextInput
              meta={meta.employeeName}
              register={register(meta.employeeName.name)}
              hasError={errors[meta.employeeName.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.employeePosition.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.employeePosition.name]}
          >
            <CustomInputSelect
              meta={meta.employeePosition}
              register={register(meta.employeePosition.name)}
              hasError={errors[meta.employeePosition.name]}
            />
          </CustomFormControl>
          {/* // Salaire Par Mois */}
          <CustomFormControl
            label={meta.grossSalary.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.grossSalary.name]}
          >
            <CustomTextInput
              meta={meta.grossSalary}
              register={register(meta.grossSalary.name)}
              hasError={errors[meta.grossSalary.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.netSalary.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.netSalary.name]}
          >
            <CustomTextInput
              meta={meta.netSalary}
              register={register(meta.netSalary.name)}
              hasError={errors[meta.netSalary.name]}
            />
          </CustomFormControl>

          <CustomFormControl
            label={meta.since.label}
            isLoading={isLoading}
            isInvalid={!!errors[meta.since.name]}
          >
            <CustomTextInput
              meta={meta.since}
              register={register(meta.since.name)}
              hasError={errors[meta.since.name]}
            />
          </CustomFormControl>
          </CC.SimpleGrid>
      </CC.Box>

      <CC.HStack my={6} justifyContent={'flex-end'}>
        <CustomButton isLoading={isSubmitting} type={'submit'}>
          <FaSave style={{ marginRight: '10px' }} /> Enregistrer
        </CustomButton>
      </CC.HStack>
    </CC.Box>
  );
};

export default ClientFormUI;
